import { PatientCommandParams } from './PatientCommandParams';
import { Command } from './Command';
import { NCZIExtension } from '../Interfaces/ncziTypes';

export type GetPatientDPNHistoryParams = PatientCommandParams & {
	confirmationId: NCZIExtension;
};

export const GetPatientDPNHistory = (
	params: GetPatientDPNHistoryParams,
): Command => {
	return {
		operation: 'VyhladajHistoriuPotvrdeniaDPN_v1',
		params,
	};
};
